import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class ProductCategoryCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product category carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement.querySelector('.swiper');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.customNavElement = sliderElement.querySelector('.js-product-category-carousel-nav');
        this.arrowNext = this.customNavElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.customNavElement.querySelector('.swiper-button-prev');

        this.init();
    }

    init () {
        new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 14,
            threshold: 10,
            centerInsufficientSlides: true,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true
            },
            breakpoints: {
                768: {
                    spaceBetween: 35
                }
            }
        });
    }
}
